import { put, takeLatest } from 'redux-saga/effects'
import {
    GET_CHANGEPASSWORD_USERINFO,
    GET_CHANGEPASSWORD_USERINFO_SUCCESSED,
    GET_CHANGEPASSWORD_USERINFO_FAILED,
    UPDATE_CHANGEPASSWORD_USERINFO,
    UPDATE_CHANGEPASSWORD_USERINFO_SUCCESSED,
    SAVE_CHANGEPASSWORD,
    SAVE_CHANGEPASSWORD_FAILED,
    SAVE_CHANGEPASSWORD_SUCCESSED
} from '../actions/actionTypes'
import { ApiService } from '../services/ApiService'
import { AuthApiService } from '../services/AuthApiService'


const _apiService = new ApiService()

const _authApiService = new AuthApiService

function* fetchChangePasswordUserInfo(action) {
  try {
    let response = yield _authApiService.getUserInformation(action.params.refnum)
    if (!response || response.error) {
      if (response && response.errorData && response.errorData.response && response.errorData.response.data && response.errorData.response.data.message) {
        var responseErrMsg = response.errorData.response.data.message
        var description = response.errorData.response.data.description
    
        yield put({
          type: GET_CHANGEPASSWORD_USERINFO_FAILED,
          message: responseErrMsg,
          infoError: responseErrMsg,
          data: Object.assign({
          }, { message: responseErrMsg, description: description })
        })
      } else {
        yield put({

          type: GET_CHANGEPASSWORD_USERINFO_FAILED,
          message: response.error || 'An error has occurred'
        })
      }
    } else {
      yield put({
        type: GET_CHANGEPASSWORD_USERINFO_SUCCESSED,
        data: Object.assign({
        }, response, { 
        currentpassword:null,
        password:null,
        confirmpassword:null,
        refnum:action.params.refnum})
      })
    }
  } catch (error) {
    yield put({
      type: GET_CHANGEPASSWORD_USERINFO_FAILED,
      message: error.message
    })
  }
}

export function* watchFetchChangePasswordUserInfo() {
  yield takeLatest(GET_CHANGEPASSWORD_USERINFO, fetchChangePasswordUserInfo)
}

function* updateChangePasswordUserInfo(action) {
        yield put({
          type: UPDATE_CHANGEPASSWORD_USERINFO_SUCCESSED,
          data: Object.assign({
          }, {} , action.params)
        })
}
  
export function* watchChangePasswordUpdateUserInfo() {
    yield takeLatest(UPDATE_CHANGEPASSWORD_USERINFO, updateChangePasswordUserInfo)
}

function* saveChangePassword(action) {
  try {
    let payload = {
      currentPassword:action.params.currentpassword,
      newPassword:action.params.password,
      confirmPassword: action.params.confirmpassword
    }
    let response = yield _authApiService.updatePassword(action.params.userLogin,payload)
    if (!response || response.error) {
        if (response && response.errorData && response.errorData.response && response.errorData.response.data && response.errorData.response.data.message) {
          var responseErrMsg = response.errorData.response.data.message
          var description = response.errorData.response.data.description
          yield put({
            type: SAVE_CHANGEPASSWORD_FAILED,
            message: responseErrMsg,
            infoError: responseErrMsg,
            data: Object.assign({
            }, { message: responseErrMsg, description: description })
          })
        } else {
          yield put({
            type: SAVE_CHANGEPASSWORD_FAILED,
            message: response.error || 'An error has occurred'
          })
        }
      } else {
      yield put({
        type: SAVE_CHANGEPASSWORD_SUCCESSED,
        data: Object.assign({
        }, action.params,response)
      })
    }
  } catch (error) {
    yield put({
      type: SAVE_CHANGEPASSWORD_FAILED,
      message: error.message
    })
  }
}

export function* watchSaveChangePassword() {
  yield takeLatest(SAVE_CHANGEPASSWORD, saveChangePassword)
}